module.exports = __webpack_public_path__ + "img/recommed-img10.c25f4163.jpg";